import React, { useEffect } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";

// Check session storage data
const checkSessionStorage = () => {
    const username = sessionStorage.getItem("username");
    const email = sessionStorage.getItem("email");
    const jwt = sessionStorage.getItem("jwt");
    return username && email && jwt;
};

// Protected route wrapper
const withAuth = (WrappedComponent) => {
    const AuthenticatedComponent = (props) => {
        const navigate = useNavigate();
        const location = useLocation();
        const isAuthenticated = checkSessionStorage();

        useEffect(() => {
            // Additional auth checks can go here (e.g., token validation)
            if (!isAuthenticated) {
                // Save the intended URL (including search parameters) before redirecting
                const intendedUrl = location.pathname + location.search;
                sessionStorage.setItem("intendedUrl", intendedUrl);
                navigate("/login", { replace: true });
            }
        }, [isAuthenticated, navigate, location]);

        // Immediately redirect if not authenticated
        if (!isAuthenticated) {
            // Save the intended URL for immediate redirect case as well
            const intendedUrl = location.pathname + location.search;
            sessionStorage.setItem("intendedUrl", intendedUrl);
            return <Navigate to="/login" replace />;
        }

        // Render component only when authenticated
        return <WrappedComponent {...props} />;
    };

    return AuthenticatedComponent;
};

export { checkSessionStorage };
export default withAuth;